module.exports = __webpack_public_path__ + "static/media/check-circle-tk.dfa3c3ac.svg";